import React, { useContext, useMemo } from 'react'
import {
    FaArrowAltCircleUp,
    FaCheckCircle,
    FaRegArrowAltCircleUp,
    FaRegCheckCircle,
    FaSlidersH,
    FaThList,
} from 'react-icons/fa'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { IconTooltip as Tooltip } from '../../../elem/Tooltip'
import { DataContext } from './DataContext'
import CollapseButton from '../../../elem/list/CollapseButton'

export default ({
    filterExpanded,
    toggleFilter,
    togglePromotedRecords,
    promotedRecords,
    setCollapsed,
    isCollapsed,
}) => {
    return (
        <PanelHeader extraClass={'wellPanelHeader'}>
            <div className="panelHeaderText">Well Explorer</div>
            <div className="panelHeaderControls">
                <div className="panelHeaderIconWrapper">
                    {!filterExpanded && (
                        <div
                            className="panelHeaderIconDiv"
                            data-tip={`${
                                promotedRecords
                                    ? `Do not promote Selected Records`
                                    : `Promote Selected Records`
                            }`}
                            data-for={`well-promoted-records-toggle-${promotedRecords}`}
                            onClick={() =>
                                togglePromotedRecords(!promotedRecords, 'well')
                            }
                        >
                            {promotedRecords ? (
                                <FaArrowAltCircleUp />
                            ) : (
                                <FaRegArrowAltCircleUp />
                            )}
                            <Tooltip
                                id={`well-promoted-records-toggle-${promotedRecords}`}
                            />
                        </div>
                    )}
                    <div
                        className="panelHeaderIconDiv"
                        data-tip={`${
                            filterExpanded
                                ? 'View Well List'
                                : 'View Well Filter'
                        }`}
                        data-for={`well-view-toggle-${filterExpanded}`}
                        onClick={() => toggleFilter(!filterExpanded)}
                    >
                        {filterExpanded ? <FaThList /> : <FaSlidersH />}
                        <Tooltip id={`well-view-toggle-${filterExpanded}`} />
                    </div>

                    <CollapseButton
                        name={`well-list`}
                        isCollapsed={isCollapsed}
                        setIsCollapsed={setCollapsed}
                    />
                </div>
            </div>
        </PanelHeader>
    )
}
